// src/config.js
const API_BASE_URL =
  process.env.NODE_ENV === "development"
    ? "https://localhost:44315/api"
    : "https://profiterp.online/profit/api";

export default API_BASE_URL;

